import React from "react";
import Text from "@/components/ui/text";
import Badge from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface Props {
  isLeader: boolean;
  notificationCount: number;
  setChatDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  hadPreviousNotifications: boolean;
}

export interface SuggestedMessage {
  message: string;
  timestamp: number;
}

const HeroHeaderMessage: React.FC<Props> = ({
  isLeader,
  notificationCount,
  setChatDrawerOpen,
  hadPreviousNotifications
}: Props) => {
  const { t } = useTranslation();
  if (notificationCount === 0) {
    if (hadPreviousNotifications) {
      return <Text variant="lgBody">{t("openedChatMessage")}</Text>;
    }
    return (
      <Text variant="lgBody">
        {t(isLeader ? "leaderMessage" : "notLeaderMessage")}
      </Text>
    );
  }
  return (
    <div className="flex gap-1 items-center">
      <Text variant="lgBody">{t("youHave")}</Text>
      <Badge
        text={notificationCount.toString()}
        className="min-w-5 max-w-5 p-0 rounded-md bg-blue-600"
        textVariant="smBody"
      />
      <Text variant="lgBody">
        {t("newMessages", { count: notificationCount })}
      </Text>
      <Button variant="tertiary" onClick={() => setChatDrawerOpen?.(true)}>
        {t("openDreamer")}
      </Button>
    </div>
  );
};

export default HeroHeaderMessage;
